import type { CertGenParams } from '@yandex-int/k-common';
import { formatCityDate } from '../../utils/date/format-city-date';

interface Props extends CertGenParams {
    slug: string;
    issue_date?: string;
}

// eslint-disable-next-line complexity
export const TRBaseCertAutumn2024 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    issue_date: issueDate,
    slug,
}: Props) => {
    let image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5545908/TkzNp5wupXJtoOhJx94dm/orig';
    let title = 'Сертификат';
    let subtitle = 'получает';
    let awardDescription =
        'за участие в Конкурсе предметных навыков среди учителей информатики программы профессионального развития Кадровый резерв в ноябре 2024 года';
    let sealAdditionalClass = 'footer__seal2';
    let signer = 'Елена Краевская';
    let signerPosition = 'Руководитель сервиса<br />Яндекс Учебник';
    let sign = 'https://avatars.mds.yandex.net/get-schoolbook-images/6887102/-BaucEy53CUy-_gUtf7xC/orig';
    let upperTitle = '';
    let additionalTitleClass = '';
    let additionalPersonalInfoClass = '';
    let additionalDescriptionClass = '';
    let additionalSchoolClass = '';

    let formattedDate = formatCityDate('Москва', issueDate);

    switch (slug) {
        case 'TRSubjSkillsBaseAutumn2024':
            formattedDate = 'Москва, ноябрь 2024 года';
            upperTitle = 'Кадровый резерв учителей информатики';
            break;
        case 'TRSubjSkillsDevFinalistAutumn2024':
            formattedDate = 'Москва, ноябрь 2024 года';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/D6oMlEeJ6j1HGxIFT06NG/orig';
            upperTitle = 'Кадровый резерв учителей информатики';
            subtitle = 'призера в номинации <br/> <strong>«Программа развития»</strong> получает';
            awardDescription =
                'за призовое место в Конкурсе предметных<br/> навыков среди учителей информатики<br/> программы Кадрового резерва<br/> в ноябре 2024 года';
            break;
        case 'TRSubjSkillsDevWinnerAutumn2024':
            formattedDate = 'Москва, ноябрь 2024 года';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5406199/d0DwbngPNJwT-h2QQukgB/orig';
            upperTitle = 'Кадровый резерв учителей информатики';
            subtitle = 'победителя в номинации <br/> <strong>«Программа развития»</strong> получает';
            awardDescription =
                'за победу в Конкурсе предметных<br/> навыков среди учителей информатики<br/> программы Кадрового резерва<br/> в ноябре 2024 года';
            break;
        case 'TRSubjSkillsStructFinalistAutumn2024':
            formattedDate = 'Москва, ноябрь 2024 года';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5623482/zRrVs7TILBoZDG7xR_4SN/orig';
            upperTitle = 'Кадровый резерв учителей информатики';
            subtitle = 'призера в номинации <br/> <strong>«Состав Кадрового резерва»</strong> получает';
            awardDescription =
                'за призовое место в Конкурсе предметных<br/> навыков среди учителей информатики<br/> программы Кадрового резерва<br/> в ноябре 2024 года';
            break;
        case 'TRSubjSkillsStructWinnerAutumn2024':
            formattedDate = 'Москва, ноябрь 2024 года';
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5406199/Dh4H6tTQ2Sdpnv6WNVRCb/orig';
            upperTitle = 'Кадровый резерв учителей информатики';
            subtitle = 'победителя в номинации <br/> <strong>«Состав Кадрового резерва»</strong> получает';
            awardDescription =
                'за победу в Конкурсе предметных<br/> навыков среди учителей информатики<br/> программы Кадрового резерва<br/> в ноябре 2024 года';
            break;
        case 'TRSubjSkillsMentorAutumn2024':
            image = 'https://avatars.mds.yandex.net/get-schoolbook-images/5519467/ym_CFmCZM8cQnka27IG24/orig';
            upperTitle = 'Кадровый резерв учителей информатики';
            subtitle = `
                        <div class="content__subtitle__big">Педагога-наставника</div>
                        <div class="">подтверждает, что</div>
                        `;
            additionalTitleClass = 'mt-23';
            additionalPersonalInfoClass = 'mt-23 height-155';
            additionalDescriptionClass = 'fs-12';
            additionalSchoolClass = 'fs-12';
            awardDescription =
                'участвовал (-а) в наставнических активностях: консультировании преподавателей<br/> информатики, выстраивании индивидуальных траекторий профессионального развития, внедрении передовых педагогических<br/> практик и образовательных технологий';
            break;
    }

    return `<!DOCTYPE html>
    <html lang="ru">
        <head>
            <title>Сертификат кадрового резерва</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style>
                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
                    font-weight: 300;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                    font-weight: 400;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                    font-weight: 500;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
                    font-weight: bold;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: bold;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-bold.woff') format('woff');
                }

                @font-face {
                    font-family: 'YS Display';
                    font-weight: 800;
                    font-style: normal;
                    font-stretch: normal;

                    src: url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff2') format('woff2'),
                        url('//yastatic.net/s3/home/fonts/ys/1/display-heavy.woff') format('woff');
                }

                @page {
                    size: 210mm 297mm;
                    margin: 0;
                    padding: 0;
                }

                @media print {
                    html,
                    body {
                        width: 210mm;
                        height: 297mm;

                        box-sizing: border-box;
                    }
                }

                html {
                    position: relative;

                    margin: 0;
                    padding: 0;

                    --background-color: #ffffff;
                    --text-color: #000000;
                    --second-text-color: #363e45;
                }

                body {
                    margin: 0;

                    color: var(--text-color);

                    font-family: 'YS Text', sans-serif;
                }

                .page {
                    position: relative;

                    overflow: hidden;

                    box-sizing: border-box;

                    width: 210mm;
                    height: 297mm;

                    background: var(--background-color);

                    page-break-after: always;
                }

                .page__background {
                    position: absolute;

                    width: 100%;
                    height: 100%;

                    overflow: hidden;

                    display: flex;

                    z-index: 1;
                }

                .page__background img {
                    display: block;
                }

                .page__content {
                    height: 100%;
                    width: 100%;
                }

                .content {
                    position: relative;
                    box-sizing: border-box;

                    display: flex;

                    z-index: 5;
                }

                .content {
                    display: flex;
                    flex-direction: column;

                    width: calc(210 / 595 * 304mm);

                    margin-left: calc(210 / 595 * 48mm);
                    margin-top: calc(297 / 842 * 42mm);

                    color: var(--text-color);
                }

                .content__logo {
                    width: calc(210 / 595 * 168mm);
                }

                .logo {
                    width: 100%;
                }

                .content__upper-title {
                    font-size: calc(297 / 842 * 12mm);
                    font-weight: 700;
                    line-height: calc(297 / 842 * 15.6mm);;
                    color: var(--text-color);
                    margin-top: calc(297 / 842 * 5mm);
                }

                .content__title {
                    height: calc(297 / 842 * 62mm);

                    margin-top: calc(297 / 842 * 30mm);

                    font-weight: 500;
                    font-family: 'YS Display', 'Arial', sans-serif;
                    font-size: 54pt;
                    color: var(--text-color);
                }

                .content__subtitle {
                    font-family: 'YS Text', 'Arial', sans-serif;
                    font-style: normal;
                    font-size: 14pt;
                    line-height: calc(297 / 842 * 16.8mm);
                    margin-top: calc(297 / 842 * 8mm);
                    color: var(--text-color);
                }
                
                .content__subtitle__big {
                    font-size: calc(297 / 842 * 30mm);
                    margin-bottom: calc(297 / 842 * 8mm);
                    line-height: calc(297 / 842 * 30mm);
                    font-weight: 500;
                    width: calc(297 / 842 * 312mm);
                }

                .content__personal-info {
                    margin-top: calc(297 / 842 * 32mm);
                }

                .content__personal-info_title-multilined {
                    margin-top: calc(297 / 842 * 8mm);
                }

                .personal-info {
                    display: flex;
                    flex-direction: column;

                    height: calc(297 / 842 * 173mm);
                }

                .personal-info__name {
                    font-family: 'YS Text', 'Arial', sans-serif;
                    font-weight: 500;
                    font-size: 28pt;
                    line-height: 30.75pt;
                }

                .personal-info__school {
                    margin-top: calc(297 / 842 * 12mm);

                    font-family: 'YS Text', 'Arial', sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14pt;
                    line-height: 16.8pt;
                }

                .content__description {
                    margin-top: calc(297 / 842 * 12mm);

                    font-family: 'YS Text', 'Arial', sans-serif;
                    font-weight: 500;
                    font-size: 14pt;
                    line-height: 16.8pt;

                    height: calc(297 / 842 * 68mm);
                }

                .footer {
                    position: absolute;

                    top: calc(297 / 842 * 538mm);
                    left: 0;
                }

                .footer__date {
                    margin-top: calc(297 / 842 * 38mm);

                    font-family: 'YS Text', 'Arial', sans-serif;
                    font-weight: 400;
                    font-size: 10pt;
                    line-height: 130%;
                }

                .footer__seal {
                    position: relative;
                    width: calc(210 / 595 * 107mm);
                    height: calc(297 / 842 * 107mm);
                }

                .seal {
                    width: calc(210 / 595 * 137mm);
                    height: calc(297 / 842 * 108mm);
                }

                .signature {
                    position: absolute;

                    height: calc(297 / 842 * 75mm);
                    width: calc(210 / 595 * 120mm);

                    top: calc(297 / 842 * 37mm);
                    left: calc(210 / 595 * 12mm);
                }

                .person {
                    display: flex;
                    flex-direction: column;

                    margin-top: calc(297 / 842 * 6mm);
                }

                .person__name {
                    font-family: 'YS Text', 'Arial', sans-serif;
                    font-weight: 700;
                    font-size: 12pt;
                    line-height: 15pt;
                }

                .person__position {
                    margin-top: calc(297 / 842 * 8mm);

                    font-family: 'YS Text', 'Arial', sans-serif;
                    font-weight: 400;
                    font-size: 12pt;
                    line-height: 14pt;
                }

                .footer__date {
                    font-size: 10pt;
                    font-weight: 400;
                    line-height: 13pt;

                    margin-top: calc(297 / 842 * 26mm);
                }
                
                .mt-23 {
                    margin-top: calc(297 / 842 * 23mm);
                }
                
                .height-155 {
                     height: calc(297 / 842 * 155mm);
                }
                
                .fs-12 {
                    font-size: 12pt;
                }
                
            </style>
        </head>
        <body>
            <div class="page">
                <div class="page__background">
                    <img src="${image}" />
                </div>
                <div class="page__content content content__main">
                    <div class="content__logo">
                        <img
                            class="logo"
                            src="https://e7n.s3.yandex.net/static/certificates/2022-autumn-diag-inf/logo.svg"
                            alt="Яндекс Учебник"
                        />
                    </div>
                    ${upperTitle ? `<div class="content__upper-title">${upperTitle}</div>` : ''}
                    <div class="content__title ${additionalTitleClass}">${title}</div>
                    <div class="content__subtitle">${subtitle}</div>
                    <div class="content__personal-info personal-info ${additionalPersonalInfoClass}">
                        <div class="personal-info__name name">
                            ${lastName ? `${lastName}` : ''}<br />
                            ${firstName ? `${firstName}` : ''}<br />
                            ${middleName ? `${middleName}` : ''}
                        </div>
                        <div class="personal-info__school school ${additionalSchoolClass}">${
                            schoolName ? `${schoolName}` : ''
                        }</div>
                    </div>
                    <div class="content__description ${additionalDescriptionClass}">${awardDescription}</div>
                    <div class="content__footer footer">
                        <div class="footer__seal ${sealAdditionalClass}">
                            <img
                                class="seal"
                                src="${sign}"
                                alt="подпись"
                            />
                        </div>
                        <div class="footer__person person">
                            <div class="person__name">${signer}</div>
                            <div class="person__position">${signerPosition}</div>
                        </div>
                        <div class="footer__date">${formattedDate}</div>
                    </div>
                </div>
            </div>
        </body>
    </html>
    `;
};
